<template>
  <div
    :class="showLogo ? 'pt-4' : 'pt-[60px]'"
    class="flex flex-col items-center w-11/12 mt-[2%] px-10 pb-4 mx-auto overflow-auto bg-white rounded md:px-20 lg:w-7/12 xl:w-8/12 2xl:w-8/12 max-h-[95%] max-w-[650px] text-sm">
    <img :src="src" alt="logo" v-if="showLogo && src" class="w-20" />
    <img src="@/assets/images/logo.png" alt="logo" v-else class="w-20" />
    <h1
      class="text-center text-2xl font-medium pb-1.5 capitalize"
      :class="showLogo ? 'pt-4' : 'pt-0'">
      {{ title }}
    </h1>

    <p class="max-w-md mx-auto font-light text-center">{{ subtitle }}</p>
    <slot name="inputs"></slot>
    <slot name="button"></slot>
    <div class="w-full mt-auto"><slot name="bottom"></slot></div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: String,
  subtitle: String,
  showLogo: Boolean,
  src: String,
});
</script>
